import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import apiError from 'redux/apiErrors/reducers';
import carrierPickupLocation from 'redux/carrierPickupLocations/reducers';
import cart from 'redux/cart/reducers';
import clubMemberShipment from 'redux/clubMemberShipments/reducers';
import clubMembership from 'redux/clubMemberships/reducers';
import clubPackage from 'redux/clubPackages/reducers';
import clubSignup from 'redux/clubSignup/reducers';
import clubSubscriptionShipment from 'redux/clubSubscriptionShipments/reducers';
import club from 'redux/clubs/reducers';
import collection from 'redux/collections/reducers';
import customer from 'redux/customer/reducers';
import customerAddress from 'redux/customerAddresses/reducers';
import customerCreditCard from 'redux/customerCreditCards/reducers';
import customerMetaData from 'redux/customerMetaData/reducers';
import formError from 'redux/formErrors/reducers';
import forms from 'redux/forms/reducers';
import inventoryLocation from 'redux/inventoryLocations/reducers';
import layout from 'redux/layout/reducers';
import loyaltyTier from 'redux/loyaltyTiers/reducers';
import loyaltyTransaction from 'redux/loyaltyTransactions/reducers';
import modal from 'redux/modals/reducers';
import order from 'redux/orders/reducers';
import personalizationBlock from 'redux/personalizationBlock/reducers';
import productFilter from 'redux/productFilters/reducers';
import productTemplate from 'redux/productTemplates/reducers';
import product from 'redux/products/reducers';
import reservationAvailability from 'redux/reservationAvailabilities/reducers';
import reservationCart from 'redux/reservationCart/reducers';
import reservationType from 'redux/reservationTypes/reducers';
import reservation from 'redux/reservations/reducers';
import setting from 'redux/settings/reducers';
import shipping from 'redux/shipping/reducers';

const rootReducer = combineReducers({
  form: formReducer,
  routing: routerReducer,
  apiError,
  carrierPickupLocation,
  cart,
  club,
  clubMembership,
  clubMemberShipment,
  clubPackage,
  clubSignup,
  clubSubscriptionShipment,
  collection,
  customer,
  customerAddress,
  customerCreditCard,
  customerMetaData,
  formError,
  forms,
  inventoryLocation,
  layout,
  loyaltyTier,
  loyaltyTransaction,
  modal,
  order,
  personalizationBlock,
  product,
  productFilter,
  productTemplate,
  reservationAvailability,
  reservationCart,
  reservation,
  reservationType,
  setting,
  shipping
});

export default rootReducer;
